
// src/connects/user-selection-dialog.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import { inject } from '../helpers/context'
import { mergeArray } from '../helpers/store'
import combineHOC from '../helpers/combine-hoc'
import MentionsStore from '../actions/mentions-store'
import map from 'lodash/map'
import filter from 'lodash/filter'
import some from 'lodash/some'

export const mapStateToProps = (state)=> {
  return {
    users: state.account.items,
    isFetching: state.account.isFetching,
    hasMore: state.account.hasMore,
  }
}

function fetchUsers(dispatch, mode, offset, group, query) {
  switch(mode) {
  case 'ACCOUNT_MEMBERS':
    dispatch(actions.fetchAccountMembers(offset, query))
    return
  case 'OTHER_MEMBERS':
    dispatch(actions.fetchOtherMembers(offset, group.group_id, query))
    return
  case 'MENTION_TO_USERS':
    let mentions_ids = undefined
    MentionsStore.get((mentions_list)=> {
      if (mentions_list && mentions_list.length > 0) {
        mentions_ids = map(mentions_list, (_mentions_list)=> _mentions_list).join(',')
      }
      if (group) dispatch(actions.fetchMentionToUsers(offset, group.group_id, mentions_ids, query))
    })
    return
  case 'GROUP_MEMBERS':
  case 'GROUP_MEMBERS_MENTION':
    dispatch(actions.fetchGroupMembersUsers(group.members, query))
    return
  case 'GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS':
    dispatch(actions.fetchGroupMembersOnlyResignedMembers(offset, group.group_id, query))
    return
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    willUpdate: (props, nextProps)=> {
      // clear users data when dialog close
      if (props.ui && nextProps.ui && props.ui.active && !nextProps.ui.active) {
        props.updateUI({
          selected: undefined,
          query: undefined,
          search: false,
          mode: undefined,
          group: undefined,
          mentions: undefined,
        })
        dispatch(actions.clearFetchedUsers())
      }

      // reload when query change
      if (props.ui && nextProps.ui && nextProps.ui.active && (
        props.ui.group != nextProps.ui.group ||
        props.ui.query != nextProps.ui.query ||
        props.ui.mode != nextProps.ui.mode
      )) {
        fetchUsers(dispatch, nextProps.ui.mode, 0, nextProps.ui.group, nextProps.ui.query)
      }

      //グループに所属していないユーザーも選択した状態から再度ダイアログを開いた時にmodeをMENTION_TO_USERSに変更させる
      if(props.ui && nextProps.ui && nextProps.ui.mode == 'GROUP_MEMBERS_MENTION' && nextProps.ui.group && props.ui.active != nextProps.ui.active && nextProps.ui.selected && nextProps.ui.selected.length > 0) {
        const groupMembersHash = nextProps.ui.group.members.reduce((r, member)=> {
          r[member.user_id] = true
          return r
        }, {})
        
        const notGroupMembers = some(nextProps.ui.selected, (user) => groupMembersHash[String(user.user_id)] == null)
        if(notGroupMembers){
          nextProps.updateUI({ mode: 'MENTION_TO_USERS' })
        }
      }

      //グループに所属していないユーザーも選択した状態からグループのみ表示に切り替えた時に、所属していないユーザーは除外する
      if(props.ui && nextProps.ui && props.ui.mode == 'MENTION_TO_USERS' && nextProps.ui.mode == 'GROUP_MEMBERS_MENTION' && props.ui.selected){        
        const groupMembersHash = props.ui.group.members.reduce((r, member)=> {
          r[member.user_id] = true
          return r
        }, {})
        
        const changeMember = filter(props.ui.selected, (user) => groupMembersHash[String(user.user_id)] == true)
        nextProps.updateUI({
          selected: mergeArray('user_id', [], changeMember),
          active: true,
        })
      }
    },

    fetchUsers: (props)=> {
      var offset = props.users && props.users.length || 0
      fetchUsers(dispatch, props.ui.mode, offset, props.ui.group, props.ui.query)
    },

    onSelect: (props, user)=> {
      !props.ui.multiple && props.ui.callback && props.ui.callback(user)
      props.updateUI({
        selected: mergeArray('user_id', props.ui.selected, [user]),
        active: props.ui.multiple,
      })
    },

    selectAll: (props)=> {
      props.updateUI({
        selected: mergeArray('user_id', [], props.users),
        active: true,
      })
    },

    unselectAll: (props)=> {
      props.updateUI({
        selected: undefined,
        active: true,
      })
    },

    onFinish: (props)=> {
      props.updateUI({ active: false })
      props.ui.callback && props.ui.callback(props.ui.selected)
      if (props.ui.mode == 'MENTION_TO_USERS') {
        MentionsStore.set(props.ui.selected && map(props.ui.selected, (user)=> { return user.user_id }) || [])
      }
    },

    showUserSelectionDialog:
      (title, multiple, mode, group, selected, callback, props)=> {
        props.updateUI({ 
          active: true, 
          title, 
          multiple, 
          mode,
          group,
          callback, 
          selected, 
        })
      },
      // title: dialog title
      // multiple: multiple selection or single selection dialog
      // mode: 'ACCOUNT_MEMBERS', 'OTHER_MEMBERS', 'MENTION_TO_USERS', 'GROUP_MEMBERS', 'GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS
      // group: Array<group>
      // callback: callback when selected
      // props: will be injected by 'inject'
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({ state: {
    active: false,
    title: undefined,
    multiple: false,
    mode: undefined,
    group: undefined,
    callback: undefined,
    query: undefined,
    selected: undefined,
    search: false,
    mentions: undefined,
  }}),
  translate(),
  lifecycle,
  inject({ showUserSelectionDialog: PropTypes.func }),
)



// WEBPACK FOOTER //
// ./src/connects/user-selection-dialog.js